import React from 'react';
import { get } from 'lodash';

import { useSelector } from '../../store/utils';
import { Board } from '../../shared';

import { FormattedMessage } from 'react-intl';
import { ControlBox } from '../../atoms/control-box';
import { ParentPaper } from '../../atoms/parent-paper';
import { StatusDot } from '../../atoms/status-dot';
import { InputBox } from '../../molecules/input-box';
import { SwitchBox } from '../../molecules/switch-box';
import { RelayControlTypeSelect } from '../../organisms/relay-options-select';
import { RelaySettingsValue } from './relay-settings-value';
import { Group } from '../../organisms/group';

export const RelaySettingsService = () => {
  const relayInstall = useSelector((s) => get(s.variables, 'RELAY_INSTALL'));
  const board = useSelector((s) => get(s.variables, 'BOARD'));

  const numberOfRelays = board === Board.SunBerry ? 1 : 4;

  if (!relayInstall) return null;

  return (
    <>
      {Array(numberOfRelays)
        .fill(null)
        .map((_, index) => (
          <RelaySettingsServiceItem key={index} index={index} />
        ))}
    </>
  );
};

type Props = {
  index: number;
};

export const RelaySettingsServiceItem = ({ index }: Props) => {
  const morePlugsEnabled = useSelector(
    (s) => get(s.variables, 'PL_MORE_PLUGS_NUMBER') > 3
  );
  const thermostatInstall = useSelector((s) =>
    get(s.variables, 'THERMOSTAT_INSTALL')
  );
  const relayOutputs = useSelector((s) => get(s.variables, 'RELAY_OUTPUT', []));

  const relayIsActive = relayOutputs.map((status, index) => ({
    id: index,
    isActive: status,
  }));

  return (
    <Group layout="list" key={index}>
      <ParentPaper>
        <SwitchBox
          title={
            <FormattedMessage
              id="settings.relay.item.enabled"
              defaultMessage="Relé {index}"
              values={{ index: index + 1 }}
            />
          }
          switchVariableId={`RELAY_ENABLED[${index}]`}
          fullWidth
        />
        <InputBox
          title={
            <FormattedMessage
              id="settings.relay.item.name"
              defaultMessage="Pojmenování relé"
            />
          }
          inputVariableId={`RELAY_NAME[${index}]`}
          visibility={{ variableId: `RELAY_ENABLED[${index}]` }}
          fullWidth
        />
        <ControlBox
          title={
            <FormattedMessage
              id="settings.relay.item.status"
              defaultMessage="Sepnuto"
            />
          }
          control={<StatusDot alive={relayIsActive[index].isActive} />}
          fullWidth
          visibility={{ variableId: `RELAY_ENABLED[${index}]` }}
        />
        <RelayControlTypeSelect
          index={index}
          morePlugsEnabled={morePlugsEnabled}
          thermostatInstall={thermostatInstall}
        />
        <RelaySettingsValue index={index} />
      </ParentPaper>
    </Group>
  );
};
